/**
 * Labstep
 */

import { EntityActionTransferOwnership } from 'labstep-web/components/Entity/Action/TransferOwnership';
import { ResourceActionDelete } from 'labstep-web/components/Resource/Action/Delete';
import { ResourceActionDuplicate } from 'labstep-web/components/Resource/Action/Duplicate';
import { ResourceActionShare } from 'labstep-web/components/Resource/Action/Share';
import colDefActionMenu from 'labstep-web/grid/Index/coldefs/Entity/actionMenu';
import type { Entity } from 'labstep-web/models/entity.model';
import type { Resource } from 'labstep-web/models/resource.model';

export const colDefResourceActionMenu = colDefActionMenu<Entity>(
  (params) => (
    <>
      <ResourceActionShare resource={params.data as Resource} />
      <ResourceActionDuplicate resource={params.data as Resource} />
      <EntityActionTransferOwnership
        entity={params.data as Resource}
      />
      <ResourceActionDelete resource={params.data as Resource} />
    </>
  ),
);
